import mustache from 'mustache';

document.querySelectorAll('.js-table-of-contents').forEach(($toc) => {
  // Search pattern
  const searchPattern = $toc.getAttribute('data-search-pattern') || 'h2.headline';

  // Find all headlines
  const headlines = [];
  let idEnding = 0;
  document.querySelectorAll(searchPattern).forEach(($headline) => {
    idEnding += 1;
    if (!$headline.getAttribute('id')) $headline.setAttribute('id', `headline-generated--${idEnding}`);
    headlines.push({
      href: `#${$headline.getAttribute('id')}`,
      title: $headline.lastChild.textContent,
    });
  });

  // Render table of contents
  // eslint-disable-next-line no-param-reassign
  $toc.outerHTML = mustache.render($toc.innerHTML, { headlines });
});



// WEBPACK FOOTER //
// ./src/javascripts/shared/table-of-contents.js